module.exports = __webpack_public_path__ + "img/Academic_Thinking_1.d38b745e.jpg";